import axios from 'axios';
import { API_URL } from './baseApi';
import { IGoalTrackerForCardRewardResponse } from '../components/GoalTracker/GoalTrackerTypes';

export const goalTrackerApi = {
  confirmReward: async (id: number) => {
    return await axios.post(`${API_URL}/goal-trackers/confirm-reward`, { goalTrackerId: id });
  },
  getTrackers: async (filter: string): Promise<IGoalTrackerForCardRewardResponse> =>
    await axios.get(`${API_URL}/goals`, { params: { filter } }),
  getUnreadCount: async () => await axios.get(`${API_URL}/goals/unread-count`),
  getTrackerDetails: async (id: number) => await axios.get(`${API_URL}/goals/${id}`),
  markTrackerAsRead: async (id: number) => await axios.post(`${API_URL}/goals/${id}/read`),
  registerForTracker: async (id: number) => await axios.post(`${API_URL}/goals/${id}/register`),
  cancelTrackerRegistration: async (id: number) => await axios.post(`${API_URL}/goals/${id}/cancel`),
};
